module.exports = __webpack_public_path__ + "media/images/gallery/emission_nebulae/NGC_1499/california_nebula-82b9a397198743f08db082cffd30407b.jpg";